import React, { useContext } from 'react';
import './library-carousel-item.scss';
import { SecondaryButton } from '../../../common';
import '../../onboarding-global-components/video-tiles/video-tile/video-tile.scss';
import { PopularVideoTile } from '../popular-videos/popular-video-tile';
import { useParams } from 'react-router-dom';
import { useHowToVideoContent } from '../../../../hooks/dyf/use-how-to-video-content/use-how-to-video-content';
import { useAnalytics } from '../../../../hooks/use-analytics';
import ServerContext from '../../../../contexts/serverContext';
import { Carousel } from '../../../common/carousel/carousel';
interface Props {
    carouselContent?: any;
    categoryTitle: string;
    categoryDesc: string;
    accountId: string;
}
export const LibraryCarouselItem = (props: Props) => {
    const serverContext = useContext(ServerContext);
    const baseRoot = serverContext.root
        ? serverContext.root.substring(0, serverContext.root.length - 1)
        : '';
    const howToVideoContent = useHowToVideoContent();
    const { year = '', model = '' } = useParams<{
        year?: string;
        model?: string;
    }>();
    const [fireEvents] = useAnalytics();
    const onShowCategoryVideo = (category: string) => {
        const categoryName = {
            categoryName: category,
        };
        fireEvents(
            ['dyf-video-library-cta-onclick-event'],
            undefined,
            categoryName
        );
    };
    return (
        <div className="carousel-wrapper">
            <div>
                <div className="category-heading">
                    <h2 className="category-title" tabIndex={0}>
                        {props.categoryTitle}
                    </h2>
                    <SecondaryButton
                        link={`${baseRoot}/vehicle/${model}/${year}/how-to-videos/video-library/${props.categoryTitle
                            .split(' ')
                            .join('-')
                            .toLowerCase()}/`}
                        onClick={() =>
                            onShowCategoryVideo(
                                props.categoryTitle
                                    .split(' ')
                                    .join('-')
                                    .toLowerCase()
                            )
                        }
                    >
                        {howToVideoContent?.viewAllVideosSecondaryButton}
                    </SecondaryButton>
                </div>
                <div className="category-description" tabIndex={0}>
                    {props.categoryDesc}
                </div>
            </div>
            <Carousel
                items={props.carouselContent}
                render={(item: any) => {
                    return (
                        <PopularVideoTile
                            accountId={props.accountId}
                            videoId={item.id}
                            categoryName={props.categoryTitle}
                            make={item.custom_fields.make}
                            year={item.custom_fields.year}
                            model={item.custom_fields.model}
                            name={item.name}
                            seoKey={item.seoKey}
                        />
                    );
                }}
            />
        </div>
    );
};
